import { connect } from 'react-redux'
import { last } from 'lodash'
import { filterPostsByTopicSlug } from 'hello_baby/lib'
import {
  getTopicNameForSlug,
  getTopicDescriptionForSlug,
} from 'hello_baby/reducers'

import PostListView from '../components/post-list-view'

const mapStateToProps = (state, ownProps) => {
  const { emailUrls, location, title, description } = ownProps
  const topicSlug = last(location.pathname.split('/'))

  return {
    title: title || getTopicNameForSlug(topicSlug, state),
    description: description || getTopicDescriptionForSlug(topicSlug, state),
    topicSlug,
    posts: filterPostsByTopicSlug(state.posts, topicSlug, {
      sortBy: 'title',
      order: 'asc',
    }),
    emailUrls,
  }
}

const PostsList = connect(mapStateToProps)(PostListView)

export default PostsList
